<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item :name="0" :title="$t('420')">
        <template slot="title">
          {{ $t('420') }}
          <span class="tip">{{ activeNames.includes(0) ? $t('payroll_salary_13') : $t('payroll_salary_12') }}</span>
        </template>
        <ul class="content tax">
          <li>
            <span>{{ $t('1767') }}</span>
            <el-input
              :disabled="isDisplay"
              size="small"
              v-model="activeInfo.social_security_base_min"
              @blur="social_security_base_min_blur"
              v-enterNumberPoint2
              style="width: 100px; min-width: 100px"
            ></el-input>
            <span>{{ currency }}，</span>
            <span>{{ $t('1768') }}</span>
            <el-input
              :disabled="isDisplay"
              size="small"
              v-model="activeInfo.social_security_base_max"
              @blur="social_security_base_max_blur"
              v-enterNumberPoint2
              style="width: 100px; min-width: 100px"
            ></el-input>
            <span>{{ currency }}</span>
          </li>
          <li>
            <span>{{ $t('1769') }}</span>
            <el-input
              :disabled="isDisplay"
              size="small"
              v-model="activeInfo.social_security"
              :max="100"
              v-enterNumberPoint2
              style="width: 100px; min-width: 100px"
            ></el-input>
            <span>%，</span>
            <span>{{ $t('1770') }}</span>
            <el-input
              :disabled="isDisplay"
              size="small"
              v-model="activeInfo.social_security_company"
              :max="100"
              v-enterNumberPoint2
              style="width: 100px; min-width: 100px"
            ></el-input>
            <span>%</span>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item :name="1" :title="$t('1490')">
        <template slot="title">
          {{ $t('1490') }}
          <span class="tip">{{ activeNames.includes(1) ? $t('payroll_salary_13') : $t('payroll_salary_12') }}</span>
        </template>
        <div class="content">
          <h1 class="clearfix">
            <i class="el-icon-warning"></i>
            <p v-html="$t('payroll_salary_16')"></p>
          </h1>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import './directive'
import { getSocialSecurity, saveSocialSecurity } from 'api/payroll/salary-scheme/detail'
import { mapState } from 'vuex'

export default {
  props: {
    activeObj: {
      type: Object
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isDisplay: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      activeNames: this.isShow ? [0, 1] : [],
      activeInfo: this.activeObj ? this.activeObj.data.info : {},
      cActiveInfo: this.activeObj ? this.activeObj.data.cInfo : {} // 拷贝数据，判断是否修改
    }
  },
  computed: {
    ...mapState({
      // 货币
      currency: state => state.user.company_info.currency
    })
  },
  mounted() {
    this.getSocialSecurity()
  },
  methods: {
    async getSocialSecurity() {
      const res = await getSocialSecurity({ payroll_sub_project_scheme_id: this.id || this.$route.params.id })
      if (res && res.code === 1) {
        this.activeInfo = Object.assign(this.activeInfo, res.data)
        this.cActiveInfo = JSON.parse(JSON.stringify(Object.assign(this.cActiveInfo, res.data)))
      }
    },
    saveData() {
      return saveSocialSecurity({
        payroll_sub_project_scheme_id: this.$route.params.id,
        ...this.activeInfo
      })
    },
    social_security_base_min_blur() {
      const social_security_base_min = Number(this.activeInfo.social_security_base_min) || 0
      const social_security_base_max = Number(this.activeInfo.social_security_base_max) || 0

      if (social_security_base_max && social_security_base_min > social_security_base_max) {
        this.activeInfo.social_security_base_min = this.activeInfo.social_security_base_max
      }
    },
    social_security_base_max_blur() {
      const social_security_base_min = Number(this.activeInfo.social_security_base_min) || 0
      const social_security_base_max = Number(this.activeInfo.social_security_base_max) || 0

      if (social_security_base_min && social_security_base_max < social_security_base_min) {
        this.activeInfo.social_security_base_max = this.activeInfo.social_security_base_min
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-collapse {
  border: none;
  /deep/ .el-collapse-item {
    .el-collapse-item__wrap {
      border: none;
    }
  }
}
.content {
  padding: 24px 0;
  &.tax {
    font-size: 14px;
    color: #262626;
    li + li {
      padding-top: 8px;
    }
    .el-input {
      margin: 0 4px;
    }
  }
}
.clearfix {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: normal;
  padding-bottom: 12px;
  p {
    display: inline;
  }
  /deep/ span {
    color: #262626;
  }
  .el-icon-warning {
    font-size: 16px;
    color: #5D51DA;
    margin-right: 4px;
  }
}
</style>
